export default __webpack_public_path__ + "static/media/play8.9808499b.jpg";